module.exports = __webpack_public_path__ + "static/media/share-question.c8f04dff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustrations/share-question.png
// module id = 1331
// module chunks = 1